import './SearchResultSkeleton.scss';
import { FC } from 'react';
import Skeleton from '@srm/ui/skeleton';

interface ISearchResultSkeletonProps {
    /**
     * Число строк-заглушек.
     * @default 4
     */
    count?: number;
}

// Скелетон результатов поиска: строка реестра (заголовок + статус / фрагмент / мета-ряд)
// для областей Документы/Отчёты/Справочники. Показывается только внутри области
// результатов — shell, заголовок и вкладки остаются на экране. Ширины варьируются
// детерминированно по индексу.
const SearchResultSkeleton: FC<ISearchResultSkeletonProps> = ({ count = 4 }) => (
    <div className="search-result-skeleton" aria-hidden="true">
        {Array.from({ length: count }).map((_, i) => (
            <div className="search-result-skeleton__row" key={i}>
                <div className="search-result-skeleton__head">
                    <Skeleton height={16} width={`${44 + ((i * 13) % 30)}%`} radius="sm" />
                    <Skeleton height={20} width={88} radius="xl" />
                </div>
                <Skeleton height={38} width="100%" radius="sm" mt={10} />
                <div className="search-result-skeleton__meta">
                    {[0, 1, 2].map((k) => (
                        <Skeleton height={11} width={92 + k * 18} radius="sm" key={k} />
                    ))}
                </div>
            </div>
        ))}
    </div>
);

export default SearchResultSkeleton;
